<div class="login-form" autocomplete="off">
  <div class="login-field-group">
    <label class="login-label" for="email">{{ 'account.login.email' | transloco }}</label>
    <div class="login-field" [class.login-field--error]="emailErrorText">
      <i class="fa-solid fa-envelope login-field__icon" aria-hidden="true"></i>
      <input
        #email
        id="email"
        class="login-input"
        [(ngModel)]="credentials.email"
        type="text"
        [placeholder]="'account.login.emailPlaceholder' | transloco"
        [disabled]="isLoading"
        (keydown.enter)="login()"
        (ngModelChange)="emailChange.emit($event)"
        autocomplete="off"
        />
      </div>
      @if (emailErrorText) {
        <div class="login-error">{{ emailErrorText }}</div>
      }
    </div>

    <div class="login-field-group">
      <label class="login-label" for="password">{{ 'account.login.password' | transloco }}</label>
      <div class="login-field" [class.login-field--error]="passwordErrorText">
        <i class="fa-solid fa-lock login-field__icon" aria-hidden="true"></i>
        <input
          id="password"
          class="login-input"
          [(ngModel)]="credentials.password"
          [type]="showPassword ? 'text' : 'password'"
          [disabled]="isLoading"
          (keydown.enter)="login()"
          autocomplete="off"
          />
          <button
            type="button"
            class="login-field__toggle"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="(showPassword ? 'account.login.hidePassword' : 'account.login.showPassword') | transloco"
            tabindex="-1"
            >
            <i
              class="fa-solid"
              [class.fa-eye]="!showPassword"
              [class.fa-eye-slash]="showPassword"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        @if (passwordErrorText) {
          <div class="login-error">{{ passwordErrorText }}</div>
        }
      </div>

      <button
        eBtn
        block
        color="primary"
        type="button"
        class="login-submit"
        [icon]="isLoading ? undefined : 'arrow-right-to-bracket'"
        [loading]="isLoading"
        [disabled]="!credentials.isValid || isLoading"
        (click)="login()"
        >
        {{ 'account.login.submit' | transloco }}
      </button>
    </div>
